import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=6378ec7e&scoped=true&"
import script from "./publications.vue?vue&type=script&lang=js&"
export * from "./publications.vue?vue&type=script&lang=js&"
import style0 from "./publications.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./publications.vue?vue&type=style&index=1&id=6378ec7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378ec7e",
  null
  
)

export default component.exports